<template>
  <div class="app-wrapper" version="1.0.0">
    <router-view v-if="authChecked" />
    
    <div v-else class="loading-state"></div>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return { authChecked: false };
  },
  async created() {
    const userName = this.$store.getters.getUserName;

    if (userName && userName.indexOf(".") === -1) {
      try {
        await this.$store.dispatch("requestUserInformation", userName);
      } catch (err) {
        console.error("Erro ao recarregar userInformation:", err);
      }
    }
    this.authChecked = true;

  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss">
@font-face {
  font-family: "Trebuchet-ms";
  src: url("assets/fonts/trebuchet-ms.ttf");
}

html,
body {
  margin: 0;
  padding: 0;
  height: auto;
  min-height: 100%;
  overflow-x: hidden;
}

.app-wrapper {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
</style>
